import React from 'react';
import { Modal, Button } from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { IMAGE_BASE_URL } from '../../common/Constants';
import { handleDownload } from '../../common/Utilities';

const baseUrl = `${IMAGE_BASE_URL}`;

const DocumentPreview = ({
  title,
  url,
  open,
  close,
  type,
  onNext,
  onBefore,
  showArrow,
}) => {
  const DownloadDocumentFile = async () => {
    fetch(baseUrl + url?.URL)
      .then((response) => {
        console.log('DOWNLOADRESP', response);
        if (!response.ok) {
          throw new Error(
            `Failed to download: ${response.status} ${response.statusText}`
          );
        }
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'document';
        console.log(a);
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error('Error downloading file:', error);
      });
  };

  return (
    <>
      <Modal
        open={open}
        title={title}
        onOk={() => {
          handleDownload(
            `${baseUrl + url?.URL}`
          );
        }}
        onCancel={close}
        centered
        okText={'Download'}
        cancelText={'Close'}
        width={700}
        footer={
          <div className='flex justify-between'>
            <div>
              {showArrow && (
                <>
                  <span
                    className='cursor-pointer'
                    key='before'
                    onClick={() => {
                      console.log("BEFOREINDEX", url?.currentFileIndex)
                      if (url?.currentFileIndex > 0) {
                        onBefore(url?.currentFileIndex - 1)
                      } else {
                        onBefore(0)
                      }

                    }}
                  >
                    <LeftOutlined />
                  </span>
                  <span className='cursor-pointer' key='next' onClick={() => {
                    if (url?.currentFileIndex < url?.totalFilesLength - 1) {
                      onNext(url?.currentFileIndex + 1)
                    } else {
                      onNext(url?.currentFileIndex)
                    }
                  }}>
                    <RightOutlined />
                  </span>
                </>
              )}
            </div>
            <div>
              <span>
                {url?.currentFileIndex + 1} - {url?.totalFilesLength}
              </span>
            </div>
            <div>
              <Button key='back' onClick={close}>
                Close
              </Button>
              <Button
                key='download'
                type='primary'
                onClick={() => {
                  handleDownload(
                    `${baseUrl + url?.URL}`
                  );
                }}
              >
                Download
              </Button>
            </div>
          </div>
        }
      >
        {type === "Image" ? (
          < div className='flex items-center justify-center mb-[20px]'>
            <img
              src={IMAGE_BASE_URL + url?.URL}
              className='max-w-full max-h-[500px]'
              alt='Document'
            />
          </div>
        ) : (
          <div className='flex items-center justify-center mb-[20px]'>
            <iframe
              src={IMAGE_BASE_URL + url?.URL}
              id='pdf'
              title='PDF Viewer'
              width='100%'
              height='500px'
            />
          </div>
        )}
      </Modal >
    </>
  );
};

export default DocumentPreview;
